<template>
    <div class="metro-box-wrapper">
        <div class="heading">
            <h3>Opciones de Sala</h3>
        </div>
        <div class="content">
            <p class="line18">Seleccione los servicios extra de la sala</p>
            <div class="form-horizontal mt-15">
                <div class="form-group">
                    <label class="col-sm-4 col-md-3 control-label">Videoconferencia</label>
                    <div class="col-sm-6 col-md-6">
                        <select class="custom-select">
                            <option value="0">Seleccione</option>
                            <option value="1">Si</option>
                            <option value="2">No</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-4 col-md-3 control-label">Catering</label>
                    <div class="col-sm-6 col-md-6">
                        <select class="custom-select">
                            <option value="0">Seleccione</option>
                            <option value="1">Si</option>
                            <option value="2">No</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "roomForm"
    }
</script>

<style scoped>

</style>